import {
  PageTemplateTypes,
  PageWorkflowStatus
} from 'shared/types/global'
import { ProjectDocument } from 'shared/types/layoutcreator/graphql'

import { PageTypes } from './type'

export const transformDocumentsToDndPages = (
  documents: ProjectDocument[]
) => {
  const contentPages = documents.map(document => {
    return {
      id: document.id,
      type: PageTypes.content,
      index: document.index!, // TODO: strictly define on backend
      contentData: {
        templateType: document.type as PageTemplateTypes,
        name: document.name,
        previewUrl: document.previewUrl,
        number: document.index! + 3, // TODO: fetch from backend
        workflowStatus:
          (document.workflowStatus as PageWorkflowStatus) ||
          PageWorkflowStatus.default
      }
    }
  })

  return [
    {
      id: PageTypes.coverFront,
      type: PageTypes.coverFront,
      index: 0,
      contentData: null
    },
    ...contentPages,
    {
      id: PageTypes.coverBack,
      type: PageTypes.coverBack,
      index: contentPages.length + 1,
      contentData: null
    }
  ]
}

export const isCoverPage = (id: string) => {
  return id === PageTypes.coverFront || id === PageTypes.coverBack
}
